import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CurrencyConvertPipe } from 'src/app/services/custom-currency.pipe';
import { LocationManagerService } from 'src/app/services/location/location-manager.service';
import { PurchaseOrderManagerService } from 'src/app/services/purchase-order/purchase-order-manager.service';
import { PurchaseOrderPDFComponent } from '../../../purchase-order-pdf/purchase-order-pdf.component';
import { FormUtils } from 'src/app/shared-ui/utils/form-utils';
import { PurchaseOrderLineItem } from 'src/app/services/purchase-order/purchase-order-line-item.model';
import { Utils } from 'src/app/services/utils.service';
import { Contact } from 'src/app/services/vendor/contact.model';
import { PurchaseOrderMetals } from 'src/app/services/purchase-order/purchase-order-metals.model';
import { DecimalPipe } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'ls-uk-compliance-page',
  templateUrl: './uk-compliance-page.component.html',
  styleUrl: './uk-compliance-page.component.less',
  animations: [
    trigger('fade', [
        transition(':enter', [
            style({
              opacity: 0
            }),
            animate('500ms ease-in', style({
              opacity: 1
            }))
          ]), 
        transition(':leave', [
            style({
              opacity: 1
            }),
            animate('500ms ease-out', style({
              opacity: 0
            }))
          ]),
    ])
  ]
})
export class UkCompliancePageComponent implements OnInit {
    @Output() signatureCompleted = new EventEmitter<boolean>();
    contactForm = this.fb.group({
        firstName: [{value: '', disabled: true}, Validators.required ],
        lastName: [{value: '', disabled: true}, Validators.required ],
        email: ['', [ Validators.required ]],
    });

    detailsForm = this.fb.group({
        sortCode: ['', [ Validators.required ]],
        accountTitle: ['', [ Validators.required ]],
        accountNumber: ['', [ Validators.required ]],
        iban: ['', [ Validators.required ]],
        vatNumber: ['', [ Validators.required ]],
        notes: ['', [ ]],
    });
    signatureVisible: boolean =  true;
    selectedContact: Contact = new Contact();
    location: any;
    metals: PurchaseOrderMetals;
    metalsStr: string;

    get logoUrl(){
        return 'assets/images/elemental/elemental_resource_management.png?q=2';
    }

	constructor(public poManager: PurchaseOrderManagerService,
                private locationManager: LocationManagerService,
                private messageService: MessageService,
                private currencyPipe: CurrencyConvertPipe,
                private numberPipe: DecimalPipe,
                private fb: UntypedFormBuilder)
    { }
    onContactChanged(event: any){
        let contact = event.value as Contact;
        this.contactForm.controls.firstName.setValue(contact.firstName)
        this.contactForm.controls.lastName.setValue(contact.lastName)
        this.contactForm.controls.email.setValue(contact.email)
    }
    initSignature(){
        this.signatureVisible = true;
    }

    ngOnInit(): void {
        if(this.poManager.current == null)
            return;
        this.locationManager.getCurrentLocation().subscribe(location =>
        {
            this.location = location;
        });
        this.poManager.getMetals(this.poManager.current.id).subscribe(poMetals => {
            this.metals = poMetals;

            this.metalsStr = this.numberPipe.transform(2.1, '1.2-2')
        })
    }

    onConfirmGeneralPage(): void {
        if(this.contactForm.valid && this.detailsForm.valid && this.poManager.current.purchaseDate != null) {
            this.signatureVisible = false;
            setTimeout(() => {
                this.signatureCompleted.emit(true);
            }, 500)
            return;
        }

        this.messageService.add({
            severity: 'error',
            summary: `Purchase Order Details`,
            detail: `Please fill required fields.`
        });

    }
    onCancel(): void {
        this.signatureVisible = false;
        setTimeout(() => {
            this.signatureCompleted.emit(false);
            this.clearFields();
        }, 500)
    }
    clearFields(){
        this.contactForm.reset();
        this.detailsForm.reset();
        this.selectedContact = new Contact();
    }
    generateSignaturePage(parent: PurchaseOrderPDFComponent): void {
        this.createHeader(parent);
        parent.createNewPdfPage(false);
        this.generateListPage(parent);
        this.generateTotalsPage(parent);
        this.generateSubtotalSection(parent);

        this.clearFields();
    }
    
    generateListPage(parent: PurchaseOrderPDFComponent): void {
        let pdf = parent.pdf;
        let general = parent.pdfDimensions.general;
        let po = this.poManager.current;

        let currentY = general.marginTop;
        pdf.addImage(this.logoUrl, 'PNG', general.marginLeft, currentY, general.logoWidth * .7, general.logoHeight * .7);
        pdf.setFontSize(general.regularFontSize + 2);

        pdf.text('CHECKLIST', general.bodyWidth + general.marginLeft - pdf.getTextWidth('CHECKLIST'), currentY + parent.lineHeight);
        pdf.setFontSize(general.regularFontSize);

        currentY += (general.logoHeight * .7) + 10;
        pdf.rect(general.marginLeft, currentY, general.bodyWidth, .4);
        currentY += 15

        pdf.setFontSize(general.regularFontSize);
        pdf.setFont(pdf.getFont().fontName, 'bold');
        let paddingTop = 3;
        pdf.text('EMAIL:', general.marginLeft, currentY);
        pdf.text('DATE:', general.marginLeft, (currentY + paddingTop) + pdf.getTextDimensions("EMAIL").h);
        pdf.text('SUPPLIER NAME:', general.marginLeft, (currentY + (paddingTop * 2)) + (pdf.getTextDimensions("EMAIL").h * 2));
        
        pdf.setFont(pdf.getFont().fontName, 'normal');
        pdf.text(this.contactForm.controls.email.value.toLocaleUpperCase(), general.marginLeft + pdf.getTextWidth('EMAIL:') + 5, currentY);
        pdf.text(FormUtils.formatToFullDate(this.poManager.current.purchaseDate).toLocaleUpperCase(), general.marginLeft + pdf.getTextWidth('DATE:') + 5, (currentY + paddingTop) + pdf.getTextDimensions("EMAIL").h);
        pdf.text(this.selectedContact.fullName.toLocaleUpperCase(), general.marginLeft + pdf.getTextWidth('SUPPLIER NAME:') + 5, (currentY + (paddingTop * 2)) + (pdf.getTextDimensions("EMAIL").h * 2));
        currentY += 3;

        pdf.setFont(pdf.getFont().fontName, 'bold');
        pdf.setFontSize(general.regularFontSize + 12)
        let elementLeft = general.bodyWidth + general.marginLeft - pdf.getTextWidth('RH') - 20;
        let elementSpaceBetween = 75;
        let elementWidth = pdf.getTextWidth('RH');
        pdf.text("RH", elementLeft, currentY + 2)
        pdf.text("PD", elementLeft - elementSpaceBetween, currentY + 2)
        pdf.text("PT", elementLeft - (elementSpaceBetween * 2), currentY + 2)

        let rhPrice = this.currencyPipe.transform(this.metals.rhPrice, po.currency, false);
        let pdPrice = this.currencyPipe.transform(this.metals.pdPrice, po.currency, false);
        let ptPrice = this.currencyPipe.transform(this.metals.ptPrice, po.currency, false);

        pdf.setFont(pdf.getFont().fontName, 'normal');
        pdf.setFontSize(general.regularFontSize + 4);
        
        let totalsY = currentY + pdf.getTextDimensions(rhPrice).h + 2;
        pdf.text(rhPrice, elementLeft + (elementWidth / 2) - (pdf.getTextWidth(rhPrice) / 2), totalsY)
        pdf.text(pdPrice, elementLeft - elementSpaceBetween + (elementWidth / 2) - (pdf.getTextWidth(pdPrice) / 2), totalsY)
        pdf.text(ptPrice, elementLeft - (elementSpaceBetween * 2) + (elementWidth / 2) - (pdf.getTextWidth(ptPrice) / 2), totalsY)

        currentY += 28;
        pdf.setFillColor('#FFA729');
        pdf.rect(general.marginLeft, currentY, general.bodyWidth, .5, 'F');
        
        let columns = [
            { title: 'ID', widthPercent: 20, align: 'left', propertyName: 'id' },
            { title: 'REFERENCE', widthPercent: 30, align: 'left', propertyName: 'converterPartNumber', extra: 'converterGroupName'},
            { title: 'FILLING', widthPercent: 10, align: 'center', propertyName: 'levelPercentageText'},
            { title: 'QTY', widthPercent: 10, align: 'right', propertyName: 'quantity'},
            { title: 'UNIT PRICE', widthPercent: 15, align: 'right', 
                calcFunc: (item) => this.currencyPipe.transform(item.pricePerItem, po.currency)
            },
            { title: 'SUBTOTAL', widthPercent: 15, align: 'right', 
                calcFunc: (item) => this.currencyPipe.transform(item.pricePerItem * item.quantity * (item.levelPercentage ?? 1), po.currency)
            },
        ]

        parent.result.bottomOfOutput = currentY + 3;
        parent.result.borderColor = '#FFA729';
        general.colors.tableHeaderColor = '#FFA729';
        pdf.setFont(pdf.getFont().fontName, 'bold');
        
        parent.createTableHeader(columns, true, true, parent.pdfDimensions.general.bodyWidth, general.regularFontSize - 2)
        pdf.setFont(pdf.getFont().fontName, 'normal')

        po.lineItemsAllConverters
        .forEach((item, idx) => { 
            parent.checkForBottomOfPage(parent.tableLineHeight, false)
            this.outputEuTableLine(parent, item, columns, true, idx)
        })

        pdf.setFillColor('#f0f0f0');
        pdf.rect(general.marginLeft, parent.result.bottomOfOutput + 10, general.bodyWidth, pdf.internal.pageSize.height - parent.result.bottomOfOutput - (general.marginTop * 2), 'F')

        general.colors.tableHeaderColor = '#AAA';
    }

    private generateTotalsPage(parent: PurchaseOrderPDFComponent): void {
        let pdf = parent.pdf;
        let general = parent.pdfDimensions.general;
        parent.result.bottomOfOutput = general.marginTop;
        let divider = () => {parent.pdf.rect(general.marginLeft, parent.result.bottomOfOutput, general.bodyWidth, .4, 'F')}
        
        pdf.setFillColor('#525252');
        parent.createNewPdfPage(false);

        let totals = [
            {key: 'Total Grams', value: '', fontSize: general.regularFontSize - 1},
            {key: 'Total Pt', value: `${this.numberPipe.transform(this.metals.ptWeight, '1.2-2')}g`, fontSize: general.regularFontSize - 3},
            {key: 'Total Pd', value: `${this.numberPipe.transform(this.metals.pdWeight, '1.2-2')}g`, fontSize: general.regularFontSize - 3},
            {key: 'Total Rh', value: `${this.numberPipe.transform(this.metals.rhWeight, '1.2-2')}g`, fontSize: general.regularFontSize - 3},
            {key: 'Total Monolith Weight', value: `${this.numberPipe.transform(this.metals.totalMonolithWeight, '1.2-2')}g`, fontSize: general.regularFontSize - 1},
        ]

        divider();
        totals.forEach(item => {
            this.addLine(parent, item);
            divider();
        })
        parent.result.bottomOfOutput += 3;
    }

    private generateSubtotalSection(parent: PurchaseOrderPDFComponent): void {
        let pdf = parent.pdf;
        let general = parent.pdfDimensions.general;
        
        pdf.setFillColor('#000');
        pdf.setFontSize(general.regularFontSize + 2);
        pdf.setTextColor('#FFF');
        pdf.rect(general.marginLeft, parent.result.bottomOfOutput, general.bodyWidth, pdf.getTextDimensions('AVERAGES').h + 5, 'F');
        //pdf.text('AVERAGES', general.marginLeft + 2, parent.result.bottomOfOutput + pdf.getTextDimensions('AVERAGES').h + 1)
        pdf.text('SUBTOTALS', ((general.marginLeft + general.bodyWidth) / 2) - (pdf.getTextWidth('SUBTOTALS') / 2), parent.result.bottomOfOutput + pdf.getTextDimensions('AVERAGES').h + 1)
        parent.result.bottomOfOutput += pdf.getTextDimensions('AVERAGES').h + 16;

        pdf.setTextColor('#000');
        pdf.text("AVGERAGE", general.marginLeft + 2, parent.result.bottomOfOutput)
 
        let grandTotal = this.poManager.current.totalPrice;
        let itemsCount = this.poManager.current.totalNumConverters + this.poManager.current.numMiscellaneous;
        let avg = grandTotal / itemsCount;
        let metallicSubText = `${itemsCount} X ${this.currencyPipe.transform(avg, this.poManager.current.currency)}`;

        pdf.text(metallicSubText, ((general.marginLeft + general.bodyWidth) / 2) - (pdf.getTextWidth(metallicSubText) / 2), parent.result.bottomOfOutput)

        let itemsTotal = this.currencyPipe.transform(itemsCount * avg, this.poManager.current.currency);

        pdf.text(itemsTotal, general.bodyWidth + general.marginLeft - pdf.getTextWidth(itemsTotal) - 2, parent.result.bottomOfOutput)
        parent.result.bottomOfOutput += pdf.getTextDimensions(itemsTotal).h + 3
        //pdf.text(ceramicTotal, general.bodyWidth + general.marginLeft - pdf.getTextWidth(ceramicTotal) - 2, parent.result.bottomOfOutput + pdf.getTextDimensions(metallicSubText).h + 3)
        // parent.result.bottomOfOutput += pdf.getTextDimensions(ceramicTotal).h + 3
        //pdf.text(catDpfTotal, general.bodyWidth + general.marginLeft - pdf.getTextWidth(catDpfTotal) - 2, parent.result.bottomOfOutput + (pdf.getTextDimensions(ceramicSubText).h * 2) + 6)
        // parent.result.bottomOfOutput += pdf.getTextDimensions(catDpfTotal).h + 3

        pdf.setFillColor('#FFA729')
        pdf.rect(general.marginLeft, parent.result.bottomOfOutput, general.bodyWidth, .5, 'F');
        parent.result.bottomOfOutput += 15;
        pdf.setFontSize(general.regularFontSize + 3);
        pdf.setTextColor('#FFA729')
        pdf.text(itemsCount.toString(), general.marginLeft, parent.result.bottomOfOutput);
        pdf.text(this.currencyPipe.transform(grandTotal, this.poManager.current.currency), general.bodyWidth + general.marginLeft - pdf.getTextWidth(this.currencyPipe.transform(grandTotal, this.poManager.current.currency)), parent.result.bottomOfOutput);
        
        pdf.setTextColor('#000')
        pdf.text('UNITS', general.marginLeft + pdf.getTextWidth(itemsCount.toString()) + 2, parent.result.bottomOfOutput);
        pdf.text('GRAND TOTAL', general.marginLeft + general.bodyWidth - pdf.getTextWidth(this.currencyPipe.transform(grandTotal.toString(), this.poManager.current.currency)) - pdf.getTextWidth("GRAND TOTAL") - 4, parent.result.bottomOfOutput);
        parent.result.bottomOfOutput += pdf.getTextDimensions('GRAND TOTAL').h + 4;
        
        pdf.setTextColor('#c90000')
        pdf.setFontSize(general.regularFontSize - 2);
        pdf.text('We reserve the right to revalue', general.marginLeft, parent.result.bottomOfOutput);

        this.poManager.current.purchaseDate.setHours(this.poManager.current.purchaseDate.getHours() + 24)
        let validTillText = `Price valid till: ${FormUtils.formatToMediumDateTime(this.poManager.current.purchaseDate)}`;
        pdf.text(validTillText, general.marginLeft + general.bodyWidth - pdf.getTextWidth(validTillText), parent.result.bottomOfOutput)
        pdf.setFillColor('#f0f0f0');
        pdf.rect(general.marginLeft, parent.result.bottomOfOutput + 10, general.bodyWidth, pdf.internal.pageSize.height - parent.result.bottomOfOutput - (general.marginTop * 2), 'F')

    }

    createHeader(parent: PurchaseOrderPDFComponent): void {
        const general = parent.pdfDimensions.general;
        let pdf = parent.pdf;
        let po = this.poManager.current;

        pdf.setFontSize(general.regularFontSize);

        let invoiceNumberSection = { top: general.marginTop + 20, left: general.marginLeft}
        pdf.text(`INVOICE NUMBER: ${po.number}`, invoiceNumberSection.left, invoiceNumberSection.top);
        
        let logoSection = {top: invoiceNumberSection.top + 10, left: general.marginLeft + 10}
        pdf.addImage(this.logoUrl, 'PNG', logoSection.left, logoSection.top, general.logoWidth, general.logoHeight);

        let dateSection = {top: invoiceNumberSection.top, left: (general.bodyWidth / 2) + 50}
        let docDate = `Date: ${FormUtils.formatToLongDate(this.poManager.current.purchaseDate)}`;
        pdf.text(docDate, dateSection.left, dateSection.top);

        let sectionTitle = 'Purchase Order';
        pdf.setFontSize(general.regularFontSize + 10);
        parent.lineHeight
        let titleSection = {top: logoSection.top + (general.logoHeight / 2 ), left: dateSection.left, lineHeight: pdf.getTextDimensions(sectionTitle).h}
        pdf.text(sectionTitle, titleSection.left, titleSection.top)

        pdf.setFontSize(general.regularFontSize + 4);
        let supplierTitleSection = {top: logoSection.top + general.logoHeight + parent.lineHeight + 15, left: general.marginLeft}
        pdf.text('Supplier Information', supplierTitleSection.left, supplierTitleSection.top);

        let senderTextSection = {top: titleSection.top + titleSection.lineHeight, left: dateSection.left, lineHeight: pdf.getTextDimensions('Sender').h}
        pdf.text(`Sender: ${po.vendor.email}`, senderTextSection.left, senderTextSection.top);
        pdf.setFontSize(general.regularFontSize);
        let supplierDetails = {
            Name: po.vendorName,
            City: po.vendor.city ?? 'N/A',
            Address: po.vendor.address != null ? po.vendor.address : 'N/A',
            'Post Code': po.vendor.zip ?? 'N/A',
            'Sort Code': this.detailsForm.controls.sortCode.value,
            'Account Title': this.detailsForm.controls.accountTitle.value,
            'Account Number': this.detailsForm.controls.accountNumber.value,
            'IBAN Number': this.detailsForm.controls.iban.value
        }
        let supplierExtra = {
            Notes: this.detailsForm.controls.notes.value ?? '-',
            Date: FormUtils.formatToLongDate(this.poManager.current.purchaseDate),
            'Phone No': this.selectedContact.phone
        }

        let sectionTop = senderTextSection.top + (senderTextSection.lineHeight * 2) + 5
        let lastSupplierItemY = 0;
        Object.keys(supplierDetails).forEach((item, index) => {
            pdf.text(`${item}:`, senderTextSection.left, sectionTop);
            let sectionLeft = senderTextSection.left + pdf.getTextWidth(item) + 5;
            let maxWidth = pdf.internal.pageSize.width - sectionLeft - general.marginLeft;
            pdf.text(supplierDetails[item], sectionLeft, sectionTop, {maxWidth: maxWidth, lineHeightFactor: 0.95})
            sectionTop += ((Math.ceil(pdf.getTextWidth(supplierDetails[item]) / maxWidth) + 1) * pdf.getTextDimensions(item).h)
            
            lastSupplierItemY = sectionTop + pdf.getTextDimensions(item).h;
        });

        Object.keys(supplierExtra).forEach((item, index) => {
            let sectionLeft = general.marginLeft + pdf.getTextWidth(item) + 5;
            let maxWidth = (general.bodyWidth / 2) - sectionLeft
            if(index == 0)
                sectionTop -= ((Math.ceil(pdf.getTextWidth(supplierExtra[item]) / maxWidth) + 0) * pdf.getTextDimensions(item).h)
            else
                sectionTop -= ((Math.ceil(pdf.getTextWidth(supplierExtra[item]) / maxWidth) + 1) * pdf.getTextDimensions(item).h)
            pdf.text(`${item}:`, general.marginLeft, sectionTop);
            pdf.text(supplierExtra[item], sectionLeft, sectionTop, {maxWidth: maxWidth, lineHeightFactor: 0.95})
        });

        let columns = [
            { title: 'Description', widthPercent: 50, align: 'left', propertyName: 'converterGroupName' },
            { title: 'Qty', widthPercent: 20, align: 'right', propertyName: 'quantity'},
            { title: 'Total', widthPercent: 30, align: 'right', 
                calcFunc: (item) => this.currencyPipe.transform(item.totalPrice, po.currency, true)}
        ]

        parent.result.bottomOfOutput = lastSupplierItemY;
        parent.result.borderColor = '#525252';
        pdf.setTextColor(parent.result.borderColor)
        pdf.setFont(pdf.getFont().fontName, 'bold')
        parent.createTableHeader(columns, true, false, parent.pdfDimensions.general.bodyWidth, general.regularFontSize + 4)
        pdf.setFont(pdf.getFont().fontName, 'normal')

        let item = new PurchaseOrderLineItem();
        item.converterGroupName = 'Converter'
        item.quantity = Utils.sum(po.lineItemsAllConverters, 'quantity');
        item.totalPrice = Utils.sum(po.lineItemsAllConverters, 'totalPrice');
        item.quantity += Utils.sum(po.lineItemsMiscellaneous, 'quantity');
        item.totalPrice += Utils.sum(po.lineItemsMiscellaneous, 'totalPrice');

        this.outputEuTableLine(parent, item, columns)

        pdf.setFont(pdf.getFont().fontName, 'bold')
        this.createEuSubtotalLine(parent, item, columns);
        pdf.setFont(pdf.getFont().fontName, 'normal')

        let summaryData = {
            Subtotal: this.currencyPipe.transform(item.totalPrice, po.currency),
            Other: this.currencyPipe.transform(0, po.currency),
            'Vat%': '0%',
            'VAT Amount': this.currencyPipe.transform(item.totalPrice, po.currency),
            'Invoice Total': this.currencyPipe.transform(item.totalPrice, po.currency)
        }
        let summarySection = {top: parent.result.bottomOfOutput + (parent.lineHeight*2) + 15, left: dateSection.left}
        pdf.setTextColor(0);
        pdf.setFontSize(general.regularFontSize + 2);
        let itemTop = summarySection.top;
        Object.keys(summaryData).forEach(item => {
            pdf.text(item, summarySection.left, itemTop)
            let valueLeft = pdf.internal.pageSize.width - general.marginLeft - pdf.getTextWidth(summaryData[item]);
            pdf.text(summaryData[item], valueLeft, itemTop)
            itemTop += pdf.getTextDimensions(item).h * 2
        })

        let partWidth = ((general.bodyWidth / 2) / 2) - 10;
        let leftPartX = general.marginLeft;
        let rightPartX = leftPartX + partWidth + 20;
        let partY = summarySection.top;
        pdf.setFontSize(general.regularFontSize - 2);
        pdf.setTextColor('#9c9c9c');
        pdf.text('Buyer Remarks', rightPartX, partY);
        pdf.setTextColor(0)
        pdf.setFontSize(general.regularFontSize + 2);
        partY += parent.lineHeight + 5;

        pdf.setTextColor('#c7c7c7');
        pdf.text("Supplier Remarks", leftPartX, partY);

        pdf.setTextColor(0);
        pdf.text(po.buyerName, rightPartX, partY);
        partY += pdf.getTextDimensions(po.buyerName).h;

        pdf.rect(leftPartX, partY, partWidth, .5)
        pdf.rect(rightPartX, partY, partWidth, .5)
        partY += parent.lineHeight;

        pdf.setFontSize(general.regularFontSize);
        pdf.text(FormUtils.formatToLongDate(this.poManager.current.purchaseDate), leftPartX, partY)
        pdf.text(FormUtils.formatToLongDate(this.poManager.current.purchaseDate), rightPartX, partY)
        pdf.setFontSize(general.regularFontSize);
        partY += parent.lineHeight + 10
        
        pdf.setFontSize(general.regularFontSize - 2);
        pdf.setTextColor('#9c9c9c');
        pdf.text('Supplier VAT Number', leftPartX, partY);
        pdf.setTextColor(0)
        pdf.setFontSize(general.regularFontSize + 2);
        partY += parent.lineHeight + 5;

        pdf.text(this.detailsForm.controls.vatNumber.value, leftPartX, partY);
        partY += pdf.getTextDimensions(po.buyerName).h;
        pdf.rect(leftPartX, partY, partWidth, .5)
    }
    
    outputEuTableLine(parent: PurchaseOrderPDFComponent, line: any, columns: any, fillOnlyOdds: boolean = false, idx: number = 0): void
    {
        const general = parent.pdfDimensions.general;
        let currentColumnOffset = general.marginLeft;
        const totalColumnWidthPercent = Utils.sum(columns, 'widthPercent');
        if(!fillOnlyOdds)
            parent.drawRectanglesForTableColumns(columns, parent.result.bottomOfOutput, parent.result.borderColor, '#fff', parent.pdfDimensions.general.bodyWidth, parent.pdf.getFontSize());

        if(fillOnlyOdds && idx % 2 == 1)
            parent.drawRectanglesForTableColumns(columns, parent.result.bottomOfOutput, '#f0f0f0', '#f0f0f0', parent.pdfDimensions.general.bodyWidth, parent.pdf.getFontSize())
        for (const col of columns)
        {
            const text = col.propertyName != null ? (line[col.propertyName] ?? (line['vin'] ?? '<Custom>')).toString() : col.calcFunc(line);
            const columnWidth = parent.pdfDimensions.general.bodyWidth * (col.widthPercent / totalColumnWidthPercent);
            
            parent.outputTableValue(text, col, totalColumnWidthPercent, currentColumnOffset, parent.result.bottomOfOutput);
            if(col.title == 'REFERENCE'){
                let orgFontSize = parent.pdf.getFontSize();
                let orgTextColor = parent.pdf.getTextColor();
                let extraOffset = currentColumnOffset + parent.pdf.getTextWidth(text) + 2
                parent.pdf.setFontSize(orgFontSize - 2);
                parent.pdf.setTextColor('#666666');
                parent.outputTableValue(line[col.extra].toString().toLocaleUpperCase(), col, totalColumnWidthPercent, extraOffset, parent.result.bottomOfOutput + 2);
                parent.pdf.setFontSize(orgFontSize);
                parent.pdf.setTextColor(orgTextColor);
            }
            
            currentColumnOffset += columnWidth;
        }
        parent.result.bottomOfOutput += parent.tableLineHeight;
    }

    createEuSubtotalLine(parent: PurchaseOrderPDFComponent, item: PurchaseOrderLineItem, columns: any[]): void
    {
        const general = parent.pdfDimensions.general;

        // this.result.bottomOfOutput += this.tableLineHeight / 2;
        parent.checkForBottomOfPage();

        parent.drawRectanglesForTableColumns(columns, parent.result.bottomOfOutput, parent.result.borderColor, '#fff', parent.pdfDimensions.general.bodyWidth, parent.pdf.getFontSize());
        let currentColumnOffset = general.marginLeft;
        const totalColumnWidthPercent = Utils.sum(columns, 'widthPercent');
        for (let iColumn = 0; iColumn < columns.length; iColumn++)
        {
            const col = columns[iColumn];
            const text = iColumn === 0 ? 'Total' : iColumn === 1 ? item.quantity.toString() : null;
            const columnWidth = general.bodyWidth * (col.widthPercent / totalColumnWidthPercent);
            if (text != null)
                parent.outputTableValue(text, col, totalColumnWidthPercent, currentColumnOffset, parent.result.bottomOfOutput);
            currentColumnOffset += columnWidth;
        }
    }

    private addLine(parent: PurchaseOrderPDFComponent, line: any): void {
        parent.pdf.setFontSize(line.fontSize ?? parent.pdfDimensions.general.regularFontSize)
        parent.result.bottomOfOutput += parent.pdf.getTextDimensions(line.key).h + 2;
        parent.pdf.text(line.key, parent.pdfDimensions.general.marginLeft + 2, parent.result.bottomOfOutput)
        parent.pdf.text(line.value, parent.pdfDimensions.general.marginLeft + parent.pdfDimensions.general.bodyWidth - parent.pdf.getTextWidth(line.value) - 2, parent.result.bottomOfOutput);
        
        parent.pdf.setFontSize(parent.pdfDimensions.general.regularFontSize)
        parent.result.bottomOfOutput += 4
    }
}
